import React, { FC } from 'react'

import { IconTopUpProps } from './IconTopUp.types'
import * as Styled from './styles/IconTopUp.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTopUp: FC<IconTopUpProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTopUpProps['size'],
  isResponsive = false,
}: IconTopUpProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#0de088d4-b76b-4f5e-b03c-f03da3077a2c__a)' strokeWidth='2'>
          <path d='M20.92 39.063h6' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' />
          <path
            d='M11.92 37.063c4.97 0 9-1.4 9-3.126 0-1.725-4.03-3.124-9-3.124s-9 1.399-9 3.125c0 1.725 4.03 3.124 9 3.124Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M20.92 33.938v5.9c-1.175 1.377-4.75 2.1-9 2.1s-7.825-1-9-2.378v-5.75'
            stroke='#0D0D0D'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path d='M4.92 40.822v4c1.175 1.375 4.75 2.25 9 2.25s7.825-.625 9-2v-5s0-1-2-1' stroke='#0D0D0D' strokeLinejoin='round' />
          <path
            d='M13 30.615V9.325A4.327 4.327 0 0 1 17.325 5H35v33.675A4.327 4.327 0 0 1 30.675 43h-7.44'
            stroke='#0D0D0D'
            strokeLinecap='round'
            strokeMiterlimit='10'
          />
          <path
            d='m19.637 17.778 3.938-3.933a.612.612 0 0 1 .865 0l3.922 3.933M24 27.082V14.165'
            stroke='#E60000'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='0de088d4-b76b-4f5e-b03c-f03da3077a2c__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTopUp
